const alertTypes = {
    DANGER: 'DANGER',
    DEFAULT: 'DEFAULT',
    INFO: 'INFO',
    SUCCESS: 'SUCCESS',
};

export default alertTypes;
